var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5199 19.2C47.7318 20.2436 47.8759 21.3119 47.9475 22.4H.052495C.124114 21.3119.268245 20.2436.480101 19.2H47.5199zM45.2319 12.8C45.7737 13.825 46.2434 14.8939 46.6344 16H1.36563C1.75659 14.8939 2.22634 13.825 2.76813 12.8H45.2319zM40.3171 6.40002C41.371 7.37758 42.3369 8.44865 43.2018 9.60002H4.79823C5.66306 8.44865 6.62903 7.37758 7.68296 6.40002H40.3171zM12.0186 3.2C15.5445 1.16462 19.6363 0 24 0 28.3638 0 32.4555 1.16462 35.9814 3.2H12.0186zM47.5199 28.8C47.7318 27.7563 47.8759 26.688 47.9475 25.6H.0524902C.124106 26.688.268234 27.7563.480087 28.8H47.5199zM46.6344 32H1.36565C1.75661 33.1061 2.22636 34.175 2.76815 35.2H45.2319C45.7736 34.175 46.2434 33.1061 46.6344 32zM43.2017 38.4H4.79827C5.6631 39.5514 6.62908 40.6225 7.68301 41.6H40.317C41.3709 40.6225 42.3369 39.5514 43.2017 38.4zM35.9813 44.8H12.0187C15.5446 46.8354 19.6363 48 24 48 28.3637 48 32.4554 46.8354 35.9813 44.8z",
    fill: "#E62048"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25.625H0.0541458C0.0182406 25.088 0 24.5461 0 24C0 12.1952 8.52279 2.381 19.7508 0.375C21.13 0.128594 22.55 0 24 0V25.625Z",
    fill: "#2B63D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0018 18.9036C14.1588 19.5897 13.0888 20 11.9244 20C9.20472 20 7 17.7614 7 15C7 12.2386 9.20472 10 11.9244 10C13.0871 10 14.1556 10.4091 14.9981 11.0933C14.5522 10.9247 14.0696 10.8325 13.5658 10.8325C11.2994 10.8325 9.46212 12.698 9.46212 14.9992C9.46212 17.3004 11.2994 19.1659 13.5658 19.1659C14.071 19.1659 14.5549 19.0732 15.0018 18.9036Z",
    fill: "#FADF43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 16.23L15.6983 17.7029L16.0383 15.7669L14.0752 15.6676L15.8008 14.7263L14.6545 13.1295L16.4663 13.8918L17 12L17.5337 13.8918L19.3455 13.1295L18.1992 14.7263L19.9248 15.6676L17.9617 15.7669L18.3017 17.7029L17 16.23Z",
    fill: "#FADF43"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5C36.9787 0.5 47.5 11.0213 47.5 24Z",
    stroke: "#000",
    strokeOpacity: 0.1
  })));
}

export default SvgMy;